<template>
  <a :href="post.url" class="slm-theme-list__card">
    <div v-if="post.image" class="slm-theme-list__image" v-html="post.image"></div>
    <span
      class="slm-theme-list__button slm-link-button"
    >
      {{ post.title }}
    </span>
  </a>
</template>

<script>
export default {
  name: "card-component",
  props: {
    post: {
      type: Object,
      required: true,
    },
  }
};
</script>
